import React, { useState } from 'react';
import { Popover } from '@mui/material';
import { Images } from 'utils';
import { Comments } from './comments';

/** `onOpen` fires each time the panel opens — e.g. to mark the resource as seen. */
export const CommentsPopper = ({ count = 0, buttonClassName = '', panelHeight = 610, afterSuccess, onOpen, ...commentsProps }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <button
                type="button"
                className={`comments-trigger-btn ${buttonClassName}`}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    onOpen?.();
                }}>
                <img src={count ? Images.messageCircleBlue : Images.messageCircle} alt="messageCircle" />
                {count > 0 && <span className="comments-trigger-badge">{count > 9 ? '9+' : count}</span>}
            </button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { className: 'comments-popover-paper' } }}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus>
                <Comments {...commentsProps} height={panelHeight} onClose={() => setAnchorEl(null)} afterSuccess={afterSuccess} />
            </Popover>
        </>
    );
};
